var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{attrs:{"entity-name":_vm.$t('unitGroup'),"model":_vm.model},scopedSlots:_vm._u([{key:"item.unitIds",fn:function({item}){return [_c('span',[_vm._v(_vm._s(item.resourceUnits.map(it=>it.name).join(',')))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }